import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class PowerExpression extends LeftRightBasedExpression {
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        return Math.pow(left, right);
    }
}
//# sourceMappingURL=PowerExpression.js.map